import React from 'react';
import { Box } from '@mui/material';

export interface DiagnosisPermissionContextValue {
  readOnly: boolean;
}

export const DiagnosisPermissionContext = React.createContext<DiagnosisPermissionContextValue>({
  readOnly: false,
});

export const useDiagnosisPermission = (): DiagnosisPermissionContextValue =>
  React.useContext(DiagnosisPermissionContext);

export const DiagnosisPermissionProvider: React.FC<{
  readOnly: boolean;
  children: React.ReactNode;
}> = ({ readOnly, children }) => (
  <DiagnosisPermissionContext.Provider value={{ readOnly }}>
    <Box
      component="fieldset"
      disabled={readOnly}
      sx={{ border: 'none', m: 0, p: 0, minWidth: 0, width: '100%' }}
    >
      {children}
    </Box>
  </DiagnosisPermissionContext.Provider>
);
